import { render, staticRenderFns } from "./mime-icon.vue?vue&type=template&id=7077919c&scoped=true&"
import script from "./mime-icon.vue?vue&type=script&lang=js&"
export * from "./mime-icon.vue?vue&type=script&lang=js&"
import style0 from "./mime-icon.vue?vue&type=style&index=0&id=7077919c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7077919c",
  null
  
)

export default component.exports